import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

import {
  ComposableMap,
  Geographies,
  Geography,
  Marker
} from "react-simple-maps";

const geoUrl = process.env.PUBLIC_URL 
  ? `${process.env.PUBLIC_URL}/countries-110m.json` 
  : "/countries-110m.json";

const countryCoords = {
  India: [78.9629, 20.5937],
  "United States": [-95.7129, 37.0902],
  USA: [-95.7129, 37.0902],
  US: [-95.7129, 37.0902],
  Brazil: [-51.9253, -14.2350],
  Germany: [10.4515, 51.1657],
  Canada: [-106.3468, 56.1304],
  "United Kingdom": [-3.435973, 55.378051],
  UK: [-3.435973, 55.378051],
  Australia: [133.7751, -25.2744],
  France: [2.2137, 46.2276],
  Singapore: [103.8198, 1.3521],
  "United Arab Emirates": [53.8478, 23.4241],
  UAE: [53.8478, 23.4241],
  Japan: [138.2529, 36.2048],
  China: [104.1954, 35.8617],
  Russia: [105.3188, 61.5240],
  Netherlands: [5.2913, 52.1326],
  Italy: [12.5674, 41.8719],
  Spain: [-3.7492, 40.4637],
  Mexico: [-102.5528, 23.6345],
  Indonesia: [113.9213, -0.7893],
  Pakistan: [69.3451, 30.3753],
  Bangladesh: [90.3563, 23.6850],
  "Sri Lanka": [80.7718, 7.8731],
  SriLanka: [80.7718, 7.8731],
  Malaysia: [101.9758, 4.2105],
  Philippines: [121.7740, 12.8797],
  "South Africa": [22.9375, -30.5595],
  SouthAfrica: [22.9375, -30.5595],
  Nigeria: [8.6753, 9.0820],
  Egypt: [30.8025, 26.8206],
  Turkey: [35.2433, 38.9637],
  "Saudi Arabia": [45.0792, 23.8859]
};

function VisitorWorldMap({ hideTitle = false }) {
  const [countries, setCountries] = useState({});

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const ref = doc(db, "visitors", "visitorData");
        const snap = await getDoc(ref);
        if (snap.exists()) {
          setCountries(snap.data().countries || {});
        }
      } catch (err) {
        console.error("Error fetching map countries:", err);
      }
    };

    fetchCountries();
  }, []);

  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      {!hideTitle && <h2 style={{ marginBottom: "20px" }}>🌍 Visitor World Map</h2>}

      <ComposableMap
        projectionConfig={{ scale: 130 }}
        width={800}
        height={400}
        style={{ width: "100%", height: "auto", maxHeight: "360px" }}
      >
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies && geographies.length > 0
              ? geographies.map((geo) => (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill="#1e293b"
                    stroke="#334155"
                    strokeWidth={0.5}
                    style={{
                      default: { outline: "none" },
                      hover: { fill: "#38bdf8", outline: "none", cursor: "pointer" },
                      pressed: { outline: "none" }
                    }}
                  />
                ))
              : null
          }
        </Geographies>

        {Object.entries(countries).map(([country, count], index) => {
          const coords = countryCoords[country];
          if (!coords) return null;

          return (
            <Marker key={index} coordinates={coords}>
              <circle
                r={6}
                fill="#22c55e"
                stroke="#ffffff"
                strokeWidth={1.5}
                style={{ filter: "drop-shadow(0 0 5px #22c55e)" }}
              />
              <text
                textAnchor="middle"
                y={-10}
                fill="#f8fafc"
                style={{
                  fontSize: "10px",
                  fontWeight: "600",
                  fontFamily: "inherit"
                }}
              >
                {country} ({count})
              </text>
            </Marker>
          );
        })}
      </ComposableMap>
    </div>
  );
}

export default VisitorWorldMap;